import { AppContext } from 'constants/contexts';
import { debounce } from 'lodash-es';
import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

function AppProvider({ children }) {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = debounce(() => {
      setScrollY(window.scrollY);
    }, 150);

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      handleScroll.cancel();
    };
  }, []);

  const contextValue = useMemo(() => ({
    scrollY,
  }), [scrollY]);

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
}

AppProvider.useIsScrollAtTop = (threshold = 64) => {
  const { scrollY } = useContext(AppContext);
  return scrollY < threshold;
};
export default AppProvider;
